export default __webpack_public_path__ + "static/media/element_53.3f4942a5.jpg";